export const ChangeRouting = [
  {
    path: "/contract/change/list",
    name: "contract-change-list",
    meta: { title: "合同变更" },
    component: () =>
      import(/* webpackChunkName: "contract-change" */ "@/views/contract/change/list/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/change/create",
    name: "contract-change-create",
    meta: { title: "新增合同变更", comName: "ContractChangeFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-change" */ "@/views/contract/change/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/change/edit/:id",
    name: "contract-change-edit",
    meta: { title: "编辑合同变更", comName: "ContractChangeFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-change" */ "@/views/contract/change/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/change/detail/:id",
    name: "contract-change-detail",
    meta: { title: "合同变更详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-change" */ "@/views/contract/change/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/change/flowPrint/:id",
    name: "contract-change-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/contract/change/flow-print/index.vue"
      ),
  },
];
